<template>
    <b-card-code title="แผนที่">
        <l-map :zoom="zoom" :center="mapCenter">
            <l-tile-layer :url="url" />
            <l-marker :lat-lng="mapCenter" />

        </l-map>

    </b-card-code>
</template>

<script>
/* eslint-disable global-require */
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    LMap, LTileLayer, LMarker,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
 


// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        BCardCode,

    },
    props: {
        latlon: {
            type: String,
            required: true,
        }
    },
    computed: {
    mapCenter() {
      const [lat, lng] = this.$props.latlon.split(',').map(Number)
      return [lat, lng]
    }
  },
   
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 16,
            center: [],
            markerLatLng: [],


        }
    },
}
</script>

<style lang="scss">
.vue2leaflet-map {
    &.leaflet-container {
       height: 100vh;
    }
}
</style>
